/*
 * Authors: mariushirjanu
 * Created: 26/08/2021
 */
import { NgModule } from '@angular/core';
import { Transition } from '@uirouter/angular';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { CompanyComponent } from './company.component';
import { CompanyInfoComponent } from './company-info/company-info.component';
import { STATE_COMPANY, STATE_COMPANYINFO } from '../../shared/app-states';
import { DuplicateCompaniesDialogComponent } from './company-info/duplicate-companies-dialog.component';
import { CompanyInfoService } from './company-info/company-info.service';
import { CompanyDialogComponent } from './company-dialog.component';
import { GaStateDeclaration } from '../../../type_definitions/datatypes';

export const states:GaStateDeclaration[] = [
  {
    name: STATE_COMPANY,
    url: '/company?companyId',
    component: CompanyComponent,
    resolve: [
      {
        token: 'companyId',
        deps: [ Transition ],
        resolveFn: (trans:Transition) => trans.params().companyId
      },
      {
        token: 'stateParams',
        deps: [ Transition ],
        resolveFn: (trans) => trans.params()
      }
    ],
    data: {
      translate: true
    }
  },
  {
    name: STATE_COMPANYINFO,
    url: '',
    component: CompanyInfoComponent,
    data: {
      viewTitle: 'Company',
      validate: [ 'SAVE_COMPANY' ]
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({ states }),
    CommonModule,
    SharedModule
  ],
  declarations: [
    CompanyComponent,
    CompanyDialogComponent,
    CompanyInfoComponent,
    DuplicateCompaniesDialogComponent
  ],
  providers: [
    CompanyInfoService
  ]
})
export class CompanyModule {
}